"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addAnnualMotorCommands = void 0;
var HandleEditPhoneNumberPopupCommand_1 = require("./HandleEditPhoneNumberPopupCommand");
var CheckRenewalChangesModifiedCommand_1 = require("./CheckRenewalChangesModifiedCommand");
var RemoveDriverCommand_1 = require("./RemoveDriverCommand");
var LoadVehicleDriversCommand_1 = require("./LoadVehicleDriversCommand");
var SkipPaymentChoiceFlagCommand_1 = require("./SkipPaymentChoiceFlagCommand");
var SetAdditionalDriverNameCommand_1 = require("./SetAdditionalDriverNameCommand");
var addAnnualMotorCommands = function (extensions) {
    extensions.journeyComponents.addCommand({
        id: "handleEditPhoneNumberPopup",
        component: HandleEditPhoneNumberPopupCommand_1.HandleEditPhoneNumberPopupCommand
    });
    extensions.journeyComponents.addCommand({
        id: "checkRenewalChangesModified",
        component: CheckRenewalChangesModifiedCommand_1.CheckRenewalChangesModifiedCommand
    });
    extensions.journeyComponents.addCommand({
        id: "removeDriver",
        component: RemoveDriverCommand_1.RemoveDriverCommand
    });
    extensions.journeyComponents.addCommand({
        id: "loadVehicleDrivers",
        component: LoadVehicleDriversCommand_1.LoadVehicleDriversCommand
    });
    extensions.journeyComponents.addCommand({
        id: "skipPaymentChoiceFlag",
        component: SkipPaymentChoiceFlagCommand_1.SkipPaymentChoiceFlagCommand
    });
    extensions.journeyComponents.addCommand({
        id: "setAdditionalDriverNameCommand",
        component: SetAdditionalDriverNameCommand_1.SetAdditionalDriverNameCommand
    });
};
exports.addAnnualMotorCommands = addAnnualMotorCommands;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/commands/annual/motor/index.js
// module id = 3278
// module chunks = 0